class Medical {
    constructor(apiService = null) {
        this.obj_name = 'medical';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // 檢查病歷輸入格式
    checkBaseMedicalModel(formData) {
        const validations = [
            {
                condition: formData.acknowledgment_id == null,
                message: '受理單編號遺失！請回到上一頁',
            },
            {
                condition: formData.species_category_id == -1 || formData.species_id == -1,
                message: '請選擇物種類別與物種',
            },
            {
                condition: formData.main_doctor == -1,
                message: '請選擇主治醫師',
            },
            // {
            //     condition: formData.alias_name.trim() === '',
            //     message: '請填寫別名',
            // },
            // {
            //     condition: formData.characteristics.trim() === '',
            //     message: '請填寫外觀特徵',
            // },
            // {
            //     condition: formData.location_id == -1,
            //     message: '請選擇院內位置',
            // },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // 檢查死亡流程輸入
    checkMedicalDeathModel(formData) {
        const validations = [
            {
                condition: formData.death_type == -1,
                message: '請選擇死亡方式',
            },
            {
                condition: formData.death_date.trim() === "",
                message: '請選擇死亡日期',
            },
            {
                condition: formData.death_time.trim() === "",
                message: '請選擇死亡時間',
            },
            {
                condition: !formData.is_needSpecimen && formData.body_disposal == -1,
                message: '請選擇屍體處理方式',
            },
            {
                condition: !formData.is_needSpecimen && formData.body_disposal_unit == -1,
                message: '請選擇屍體處理單位',
            },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // 檢查轉診輸入
    checkMedicalReferralModel(formData) {
        const validations = [
            {
                condition: formData.referral_date === '',
                message: '請選擇轉診日期',
            },
            {
                condition: formData.referral_unit == -1,
                message: '請選擇轉診單位',
            },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // 檢查轉收容輸入
    checkMedicalShelterModel(formData) {
        const validations = [
            {
                condition: formData.shelter_date === '',
                message: '請選擇轉收容日期',
            },
            {
                condition: formData.shelter_unit == -1,
                message: '請選擇轉收容單位',
            },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                return { status: false, message };
            }
        }

        return { status: true };
    }

    // API 方法
    //病歷 | 101搜尋病歷by晶片
    async getMedicalrecordByTracingDeviceSn(parameter) {
        return this.callApi('get', 'getMedicalrecordByTracingDeviceSn', parameter);
    }
    //病歷 | 102新增病例
    async addMedicalrecord(parameter, progressEvent = null) {
        return this.callApi('post', 'addMedicalrecord', parameter, progressEvent);
    }
    //病歷 | 103更新病例
    async updMedicalrecord(parameter, progressEvent = null) {
        return this.callApi('post', 'updMedicalrecord', parameter, progressEvent);
    }
    //病歷 | 104搜尋住院中病例
    async getMedicalrecordProcessingByKeywordWithPage(parameter) {
        return this.callApi('get', 'getMedicalrecordProcessingByKeywordWithPage', parameter);
    }
    //病歷 | 105搜尋已結案病例
    async getMedicalrecordClosedByKeywordWithPage(parameter) {
        return this.callApi('get', 'getMedicalrecordClosedByKeywordWithPage', parameter);
    }
    //病歷 | 106取得病例詳細資料
    async getMedicalrecordById(parameter) {
        return this.callApi('get', 'getMedicalrecordById', parameter);
    }
    //病歷 | 107搜尋病例
    async getMedicalrecordByKeywordWithPage(parameter) {
        return this.callApi('get', 'getMedicalrecordByKeywordWithPage', parameter);
    }
    //病歷 | 108匯入病例
    async importMedicalrecord(parameter, progressEvent = null) {
        return this.callApi('post', 'importMedicalrecord', parameter, progressEvent);
    }
}

export default Medical;
